// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".similar-ware-wrapper[data-v-457ad16b]{margin:0 auto;width:12.8rem}.similar-ware-wrapper .similar-title[data-v-457ad16b]{color:#000;font-size:.28rem;font-weight:700;height:.38rem;line-height:.38rem;margin:.12rem 0 .32rem}.similar-ware-wrapper .ware-list-wrapper[data-v-457ad16b]{overflow:visible!important;overflow:initial!important;width:100%!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
